<template>
    <div v-resize="setContentHeight">
        <!-- Top View -->
        <v-card style="border-radius: 0px" color="primary" class="pr-1"
            :height="visitBranchMenus ? '140px' : '104px'">

            <!-- Toolbar -->
            <v-toolbar id="newBookingToolbar" dark elevation="0" color="primary" style="border-bottom-right-radius: 5px; border-bottom-left-radius: 5px">
                <img img aria-label="NLB Logo" style="height: 48px; widthx: 24px" class="mr-3" 
                    :src="`${this.iconPath}nlb-logo-white.png`"/>

                <v-toolbar-title>Seat Availability</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn aria-label="Show help" @click="$router.push({ name: 'Help' }, () => {})" icon>
                    <v-icon>mdi-help-circle-outline</v-icon>
                </v-btn>

                <v-btn icon>
                    <LoginIcon />
                </v-btn>
            </v-toolbar>
        </v-card>

        <div ref="homeScrollable" class="scrollable" 
            :style="visitBranchMenus ? 'margin-top: -36px !important' : 'margin-top: -45px !important'"
        >        
            <!-- Search form not in use -->
            <div v-if="visitBranchMenus" v-show="!showSeatBookingSearchForm">
                <VisitBookingSearchForm ref="visitBookingSearchForm" />
            </div>

            <v-card class="mx-2 px-5 pt-4 pb-3 mb-2" style="border-radius: 8px"
                v-if="(!visitBranchMenus || showSeatBookingSearchForm) && settings && inputPopupSelectBranch.selectedItem">

                <div class="seatAvailMessage_cont">
                    <div style="text-align: justify; line-height:1">
                        <span style="font-size: 13px; font-weight: bold;">
                            {{ refMsg }}
                            <!-- This page is for reference only. To book a seat, tap the "New" button at the bottom of the screen. -->
                        </span>                
                    </div>
                    <div class="label" style="margin-top:.5rem">
                        <span>
                            <v-icon color="green" slot="prepend-inner">mdi-seat</v-icon>
                            Available
                        </span>
                        <span>
                            <v-icon color="red" slot="prepend-inner">mdi-cancel</v-icon>
                            Not Available
                        </span>
                    </div>
                    <div style="margin-top:.5rem">
                        <span class="label">Last Updated Time: </span>
                        <span>{{ currentTime }}</span>
                    </div>    
                </div>

                <!-- Select Library -->
                <div class="inputPopupSelectDiv" @click="inputPopupSelectBranch.show = true">
                    <span class="label">Library</span>

                    <v-text-field aria-label="Select library"
                        :value="inputPopupSelectBranch.selectedItem.name" readonly>
                        <v-icon slot="prepend-inner">mdi-library</v-icon>
                    </v-text-field>

                    <InputPopupSelect title="Library" :list="seatBranchMenus" :select.sync="inputPopupSelectBranch"/>
                </div>

                <!-- Accordion -->
                <div v-if="inputPopupSelectArea" class="accordion">
                    <Accordion v-for="(area,i) in inputPopupSelectBranch.selectedItem.areas" 
                        :areas="[area]"
                        :index="i" 
                        :key="i"  
                        :open="area.open"
                        :displaySlots="displaySlots"
                        @toggleOpen="toggleOpen"    
                    />    
                </div>
                <div v-else>
                    <span>Unable to retrieve records.</span>
                </div>
            </v-card>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapMutations, mapState } from 'vuex';
    import apiHelper from "@/helpers/apiHelper";
    import LoginIcon from "@/components/LoginIcon";
    import Accordion from "@/components/Accordion";
    import businessLogic from "@/helpers/businessLogic";
    import InputPopupSelect from "@/components/InputPopupSelect";
    import VisitBookingSearchForm from "@/components/VisitBookingSearchForm";

    require('@/assets/styles/main.css')

    export default {
        name: "Home",
        components: {
            LoginIcon,
            Accordion,
            InputPopupSelect,
            VisitBookingSearchForm,
        },

        data: () => ({
            // for data after branch is searched
            searchResponse: null, 

            // for last load/refresh time
            currentTime: null,

            // Show branch
            inputPopupSelectBranch: {
                show: false,
                selectedItem: {
                    //PublicBranchMenu
                    name: null,
                    code: null,
                },
            },

            inputPopupSelectArea: {
                show: false,
                selectedItem: null, //PublicAreaMenu (null = "All" areas)
            },
            
            displaySlots: window.$settings.seatAvailabilityMobileSlotsDisplay,

            refMsg: window.$msg.seatAvailabilityRefMsg,
        }),

        created() {
            this.getCurrentTime();
        },

        computed: {
            // Get BranchMenu from index.js 
            ...mapState(["searchResults"]),
            ...mapGetters(["seatBranchMenus"]),

            selectedBranch() { 
                return this.inputPopupSelectBranch.selectedItem; 
            },
            
            selectedArea() { 
                return this.inputPopupSelectArea.selectedItem; 
            },
        },

        methods: {
            ...mapMutations([
                "updateSearchResults",
            ]),

            //#region GET TIME

            getCurrentTime() {
                const now           = new Date();
                const hours         = this.formatTime(now.getHours());
                const minutes       = this.formatTime(now.getMinutes());
                const seconds       = this.formatTime(now.getSeconds());
                this.currentTime    = `${hours}:${minutes}:${seconds}`;
            },

            formatTime(time) {
                return time < 10 ? '0' + time : time;
            },

            //#endregion

            setContentHeight() {
                if (this.$refs.homeScrollable) {
                    const heights = this.heights();                  
                    const contentHeight = this.Accordion
                    ? heights.screen - heights.toolbarWithButtons - heights.bottombar - heights.noticeBarHeight
                    : heights.screen - heights.toolbar - heights.bottombar - heights.noticeBarHeight;

                    this.$refs.homeScrollable.style.height = contentHeight + "px";
                }
            },

            async searchSeatAvailability() {
                const branchId = this.selectedBranch.id;

                const searchResponse = await apiHelper.searchSeatAvailability(branchId);

                if (searchResponse === window.$msg.reloginRequired) {
                    // console.log("login required");
                    businessLogic.im8Logout();
                    return;
                }

                if (searchResponse && 
                    searchResponse.data && 
                    searchResponse.data.areas &&
                    searchResponse.data.areas.length) {
                        this.updateSearchResults(searchResponse.data);

                        if (searchResponse.data.found) 
                        {
                            console.log(searchResponse.data.areas);
                            
                            //this.$router.push({ name: "SeatsAvailabilities" });
                            // try {
                            //     // Route to the same page
                            //     await this.$router.push({ name: "SeatsAvailabilities" });
                            // } catch (error) {
                            //     // Handle NavigationDuplicated error
                            //     if (error.name === 'NavigationDuplicated') {
                            //         // Reload the page if navigation is duplicated
                            //         window.location.reload();
                            //     } else {
                            //         // Handle other errors
                            //         console.error(error);
                            //     }
                            // }
                        }
                }
                else {
                    // Api response did not retrieve anything, display error warning
                    this.updateResult({
                        show: true,
                        success: false,
                        title: window.$msg.noResultsFoundTitle,
                        message: window.$msg.noResultsFoundMsg,
                    });
                }
            },
            // Accordion toggleOpen method
            toggleOpen(index) {
                this.inputPopupSelectBranch.selectedItem.areas = this.inputPopupSelectBranch.selectedItem.areas.map((area, i) => {
                    if (index === i) {
                        area.open = !area.open;
                    }
                    else {
                        area.open = false;
                    }
                    return area;
                });
            },
        },

        activated() {
            this.searchResponse = this.searchResults;
            this.$nextTick(() => this.setContentHeight());
        },

        watch: {
            settings: {
                immediate: true,
                handler(newValue, oldValue) {
                    if (newValue) {
                        if (this.onsiteMode) {
                            const branch = this.seatBranchMenus.find(
                            (x) => x.id === this.mode.branchId
                            );

                            if (branch) {
                            this.inputPopupSelectBranch.selectedItem = branch;
                            return;
                            }
                        }
                        this.inputPopupSelectBranch.selectedItem = this.seatBranchMenus[0];
                    }
                },
            },
            inputPopupSelectBranch(newValue, oldValue) {
                if (newValue.selectedItem !== oldValue.selectedItem) {
                    this.inputPopupSelectArea.selectedItem = null;
                }
            },
        },
    };
</script>

<style scoped> 
    .accordion {
    width: 100%;
    }

    .accordion-item {
    border: 1px solid #ccc;
    margin-bottom: 5px;
    }

    .accordion-title {
    background-color: #f4f4f4;
    padding: 10px;
    cursor: pointer;
    }

    .accordion-title.active {
    background-color: #e0e0e0;
    }

    .accordion-content {
    padding: 10px;
    }

    .seatAvailMessage_cont {
        margin-bottom: 1rem;
    }
</style>